$dependencyManager.addDependencyCallback('swiper', () => {
    class HoverLinkSlider {
      constructor(container) {
        this.container = jQuery(container);
        this.slider = this.container.find('> .mad-slider');
        this.sliderId = this.container.data('slider-id');
        this.swiper = null;
        this.initSlider();
      }
  
      initSlider() {
        let initialSlidesPerView = 1;
        const windowWidth = window.innerWidth;
        
        if (windowWidth >= 1600) initialSlidesPerView = 4;
        else if (windowWidth >= 1200) initialSlidesPerView = 4;
        else if (windowWidth >= 991) initialSlidesPerView = 3;
        else if (windowWidth >= 768) initialSlidesPerView = 2;
        

        this.swiper = new Swiper(`.mad-slider__container[data-slider-id="${this.sliderId}"] .mad-slider__slides-container`, {
          slidesPerView: 1.5,
          centeredSlides: true,
          allowTouchMove: false, // Disable touch move to Fix Bug https://github.com/nolimits4web/swiper/issues/7148 TODO: Look for a better solution
          touchReleaseOnEdges: true,
          spaceBetween: 0,
          loop: true,
          slideClass: 'mad-slider__slide',
          wrapperClass: 'mad-slider__slides',
          navigation: {
            nextEl: `.mad-slider__container[data-slider-id="${this.sliderId}"] .mad-slider__button-next`,
            prevEl: `.mad-slider__container[data-slider-id="${this.sliderId}"] .mad-slider__button-prev`
          },
          updateOnWindowResize: true,
          breakpoints: {
            1600: {
              slidesPerView: 4,
            },
            1200: {
              slidesPerView: 4,
            },
            991: {
              slidesPerView: 4,
            },
            768: {
              slidesPerView: 3,
            },
            480: {
              slidesPerView: 2,
            }
          },
          speed: 600,
          observer: true,
          observeParents: true,
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          roundLengths: true,
          touchReleaseOnEdges: true,
          on: {
            click: (swiper) => {
              if (swiper.clickedIndex > swiper.activeIndex) {
                swiper.slideNext();
              } else {
                swiper.slidePrev();
              }
            }
          },
        });

      this.swiper.on('transitionEnd', () => {
        this.swiper.update();
      });
      
      window.addEventListener('resize', () => {
        if (this.swiper) {
          this.swiper.update();
        }
      });
  
        this.container.css('opacity', '1');
      }
    }
  
    jQuery('.mad-slider__container--hover-link').each(function() {
      new HoverLinkSlider(this);
    });
  });